import { dataFetcher } from 'core/services/requestHandler';   

const getLibrarySeatLayout = async (data = {}, config = {}) => {
  return dataFetcher('properties/getLibrarySeatLayout', data, { ...config});
};

const getSeatAvailability = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getSeatAvailability', data, {...config});
};

const getLibraryBookingBySeatId = async (data = {}, config = {}) => {
  return dataFetcher('bookings/getLibraryBookingBySeatId', data, {...config});
};

export { getLibrarySeatLayout, getSeatAvailability, getLibraryBookingBySeatId };
